import { labeled, numberOptional, guidOptional } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.array()
    .items(
      Joi.object().keys({
        idContact: guidOptional(Joi).label('Contact Ownership'),
        percent: numberOptional(Joi).label(labeled(label, 'Ownership percent'))
      })
    )
    .has(
      Joi.object().keys({
        idContact: guidOptional(Joi),
        percent: numberOptional(Joi, 1).label(labeled(label, 'Ownership percent'))
      })
    )
    .label(labeled(label, 'At least one ownership is required'))
    .messages({
      'array.hasUnknown': '{{#label}}'
    });

export default {
  schema
};
